import * as z from "zod";

export const checkContextualCloudflare = {
  name: "checkContextualCloudflare" as const,
  input: z.object({}),
  output: z.object({
    isActive: z.boolean(),
    status: z.string(),
    sslStatus: z.string(),
  }),
};
